import { createContext } from 'react';

import useFeatureFlagsQuery, {
    FeatureFlagRegistry,
} from 'redesign/apiREST/queries/useFeatureFlagsQuery';
import { useAuthManager } from 'redesign/components/common/contexts/AuthManager';

export interface FeatureFlagContextProps {
    isReady: boolean;
    hasInitializationError: boolean;
    featureFlagRegistry: FeatureFlagRegistry;
}

export const FeatureFlagContext = createContext<FeatureFlagContextProps>({
    isReady: false,
    hasInitializationError: false,
    featureFlagRegistry: {},
});

export function FeatureFlagManager({ children }: { children: JSX.Element }) {
    const { isAuthenticated } = useAuthManager();

    const [{ data: featureFlagRegistry, isSuccess: isReady, isError }] = useFeatureFlagsQuery(
        isAuthenticated()
    );

    return (
        <FeatureFlagContext.Provider
            value={{
                isReady,
                hasInitializationError: isError,
                featureFlagRegistry,
            }}
        >
            {children}
        </FeatureFlagContext.Provider>
    );
}
